const importPage = async (name) => await import(`../../page/${name}/index.js`);
// const importComponent = async (name) => await import(`../../component/${name}`);

// export { importPage, importComponent };
export { importPage };
